export default "__VITE_ASSET__BME1eD1g__"